import { useState } from 'react'

import { useRegion } from '@/entities/regions'

import { Icon } from '@/shared/ui/icon'

import cls from './basket-redirect-alert.module.scss'

export const BasketRedirectAlert = (): JSX.Element | null => {
	const { currentRegion } = useRegion()
	const [isVisible, setIsVisible] = useState(true)

	if (!isVisible) return null

	return (
		<div className={cls.root}>
			<Icon name="WarningCircle" size={20} className={cls.icon} />
			<div className={cls.content}>
				<div className={cls.message}>
					Вы сменили город на {currentRegion?.REGION_NAME} и условия вашего заказа могли измениться.
				</div>
				<p className={cls.description}>Проверьте содержимое вашей корзины и продолжайте оформление заказа</p>
			</div>
			<button type="button" className={cls.close} onClick={() => setIsVisible(false)} aria-label="Закрыть">
				<Icon name="Close" size={20} color="#b0b2b9" />
			</button>
		</div>
	)
}
